import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getRecords } from "../../services/api.service";
import { exportPageData } from "./InstallationClaimFile";

const breadcrumbItems = [];

const InstallationClaimList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    getData(projectId, contractor_id);
  }, [searchKeyword, page, pageSize]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    handleExportData(projectId, contractor_id);
  }, []);
  const getData = async (projectId, contractor_id) => {
    try {
      const payload = {
        modelName: "installations",
        whereCondition: {
          project_id: projectId,
          is_completed: true,
          status: ["installation_approved"],
        },

        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },

        search: {
          value: searchKeyword,
          searchFields: [
            "project_name",
            "installation_no",
            "order_no",
            "form_name",
            "field_name",
            "po_number",
          ],
        },
      };
      const responseData = await getRecords(payload, "/getInstallationDetails");
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewClick = (id) => {
    navigate(`/installation-claim-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },
      {
        Header: "PROJECT NAME",
        accessor: (row) => (row && row?.project_name ? row?.project_name : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION NO",
        accessor: (row) =>
          row && row?.installation_no ? row?.installation_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "PO NUMBER",
        accessor: (row) => (row && row?.po_number ? row?.po_number : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "FORM NAME",
        accessor: (row) => (row && row?.form_name ? row?.form_name : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "FIELD NAME",
        accessor: (row) => (row && row?.field_name ? row?.field_name : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION CLAIMED",
        accessor: (row) => (row && row?.is_installation_claimed ? "YES" : "NO"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION PAID",
        accessor: (row) => (row && row.is_installation_paid ? "YES" : "NO"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px" }}>
            <div
              onClick={() => {
                handleViewClick(row?.original?.installation_id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize],
  );

  const handleExportData = async (projectId, contractor_id) => {
    try {
      const payload = {
        modelName: "installations",
        whereCondition: {
          project_id: projectId,
          is_completed: true,
          status: ["installation_approved"],
        },
        pagination: { page: 1, pageSize: 100000 },
      };

      const responseData = await getRecords(payload, "/getInstallationDetails");

      if (responseData?.data.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,
        "PROJECT NAME": item?.project_name || "N/A",
        "INSTALLATION NO": item?.installation_no || "N/A",
        "ORDER NO": item?.order_no || "N/A",
        "FORM NAME": item?.form_name || "N/A",
        "FIELD NAME": item?.field_name || "N/A",
        "INSTALLATION STATUS": item?.installation_status || "N/A",
        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Installation Claim List"
              breadcrumbItems={breadcrumbItems}
            />
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InstallationClaimList;
